import React from "react";
import {PdfElementProps} from "./_models";
import {PdfImageComponent} from "./PdfImageComponent";
import {PdfH1Component} from "./PdfH1Component";
import {PdfH2Component} from "./PdfH2Component";
import {PdfAlternativeComponent} from "./PdfAlternativeComponent";
import {PdfTextComponent} from "./PdfTextComponent";
import {PdfSpaceComponent} from "./PdfSpaceComponent";

export function PdfElementComponent({config}: PdfElementProps) {
    switch (config.type) {
        case 'image':
            return (<PdfImageComponent config={config}/>)
        case 'h1':
            return (<PdfH1Component config={config}/>)
        case 'h2':
            return (<PdfH2Component config={config}/>)
        case 'alternative':
            return (<PdfAlternativeComponent config={config}/>)
        case 'text':
            return (<PdfTextComponent config={config}/>)
    }
    return (
        <PdfSpaceComponent config={config}/>
    )
}